import { useMemo } from 'react';
import { useListQuery } from '../hooks/useListQuery';

// Accept optional mutation fns from API
export default function useListController({
    defaults,
    createFn,
    readFn,
    updateFn,
    deleteFn,
    syncToUrl = true,
}) {
    const {
        state, data, loading, error,
        setPage, setSort, setFilter, setSearch, refresh,
    } = useListQuery({ defaults, fetcher: readFn, syncToUrl });

    const create = async (item) => {
        if (!createFn) throw new Error('createFn not provided');
        await createFn(item);
        refresh();
    };
    
    const remove = async (id) => {
        if (!deleteFn) throw new Error('deleteFn not provided');
        await deleteFn(id);
        refresh();
    };

    const update = async (id, changes) => {
        if (!updateFn) throw new Error('updateFn not provided');
        await updateFn(id, changes);
        refresh();
    };

    const tableProps = useMemo(() => ({
        rows: data.rows,
        sortBy: state.sortBy,
        sortDir: state.sortDir,
        onSort: setSort,
        loading,
        error,
    }), [data.rows, state.sortBy, state.sortDir, loading, error, setSort]);

    const paginationProps = useMemo(() => ({
        page: state.page,
        size: state.size,
        total: data.total,
        onPage: setPage,
    }), [state.page, state.size, data.total, setPage]);

    return {
        state,
        actions: { setPage, setSort, setFilter, setSearch, refresh, create, update, remove },
        tableProps,
        paginationProps,
    };
}
